<template>
  <component
    :is="as"
    :class="['linkable-item', { 'border-radius': borderRadius, 'hide-router-link-active': hideRouterLinkActive }]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    as: String,
    borderRadius: Boolean,
    hideRouterLinkActive: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.linkable-item {
  display: flex;
  cursor: pointer;
  text-decoration: none !important;
  color: var(--theme-color);

  &.border-radius {
    border-radius: $border-radius;

    @media($medium-down) {
      border-radius: 0;
    }
  }

  &:hover {
    background-color: var(--theme-highlight);
  }

  &:active {
    background-color: var(--theme-active);
  }

  &.router-link-exact-active:not(.hide-router-link-active) {
    background-color: var(--theme-active);
  }
}
</style>
